import React, { ReactElement } from 'react';
import { Box } from '@mui/material';
import ViewWrapper from 'components/core/Layout/ViewWrapper';
import { Spinner } from 'components/core';
import {
  issueViewBodySx,
  issueViewWrapperSx,
} from 'components/issue/UnifiedIssue/styles';
import { Color } from 'shared/utils/colors';
import { IssueViewHeaderSkeleton } from './IssueViewHeaderSkeleton';

interface IssueViewLoadingShellProps {
  spinnerReason?: string;
  issueNcrNumber?: string;
}

export function IssueViewLoadingShell({
  spinnerReason = 'loading issue view',
  issueNcrNumber,
}: IssueViewLoadingShellProps): ReactElement {
  return (
    <ViewWrapper>
      <Box sx={issueViewWrapperSx}>
        <IssueViewHeaderSkeleton issueNcrNumber={issueNcrNumber} />

        <Box
          sx={{
            ...issueViewBodySx,
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: Color.solidGray,
          }}
        >
          <Spinner reason={spinnerReason} />
        </Box>
      </Box>
    </ViewWrapper>
  );
}
